import { Injectable } from '@angular/core';

import { ClientConfigProductName, LazyClientConfig, LazyClientConfigBase, LazyClientConfigService } from '@frontend/vanilla/core';

export const horseRacingGeoLocationClientConfigFactory = (service: LazyClientConfigService) => service.get(HorseRacingGeoLocationClientConfig);

@LazyClientConfig({ key: 'hrGeoLocationConfig', product: ClientConfigProductName.HORSERACING })
@Injectable({
    providedIn: 'root',
    useFactory: horseRacingGeoLocationClientConfigFactory,
    deps: [LazyClientConfigService],
})
export class HorseRacingGeoLocationClientConfig extends LazyClientConfigBase {
    useVanilla = '';
    posAPIEndpoint = '';
    gdsUrl = '';
    initialRetryInterval = -1;
    isRetryButtonEnabled = false;
    geoCoordinatorBootstrapUrl = '';
    isEnabled = false;
    oobeeIntimation?: HorseRacingOobeeIntimationModel;
    synchronizationEvent = '';
    synchronizeCoordination = false;
    bootstrapAssetPaths: string[] = [];
    downloadAppFromDevice = false;
    downloadAppErrorMsgs = '';
    geoComplyMessage = '';
    retryInterval = -1;
}

export interface HorseRacingOobeeIntimationModel {
    readonly isEnabled: boolean;
    readonly toasterId: string;
}
